<a routerLink (click)="logout()" class="group__option">
  <div class="group__option-icon"><i class="fa-regular fa-sign-out"></i></div>
  <div class="group__option-name">{{ 'auth.signOut' | translate }}</div>
</a>
